import { getYesNoString } from 'utils/stringUtils';

export interface IYesNoProps {
  value: boolean | null | undefined;
}

export default function YesNo({ value }: IYesNoProps) {
  return <>{getYesNoString(!!value)}</>;
}
